import React, { useCallback, useContext, useRef, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import {
  ContentContainer,
  ContentSection,
  ContentWrapper,
  IconWrapper,
  Pipe,
  StepContainer,
  StepWrapper,
  StepperContainer,
  SubtileTitleContarner,
  TitleContarner,
  TitlesContainer,
} from './styles';
import BasicIcon from '../BasicIcon/BasicIcon';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { StepperProps, StatusType, IconsPropsType } from './types';
import { aniamtion } from './Animation';

export const Stepper: React.FC<StepperProps> = ({
  steps,
  initialIndex = 0,
  disableNavigation = false,
  disableSteps = [],
}) => {
  const { actualTheme } = useContext(ThemeContext);
  const [index, setIndex] = useState(initialIndex);

  const IconConfig: { [key in StatusType]: IconsPropsType } = {
    success: {
      iconName: 'check-circle',
      color: actualTheme.stepper.success.color,
      pipeColor: actualTheme.stepper.success.pipeColor,
    },
    error: {
      iconName: 'x-circle',
      color: actualTheme.stepper.error.color,
      pipeColor: actualTheme.stepper.error.pipeColor,
    },
    actual: {
      iconName: 'circle',
      color: actualTheme.stepper.actual.color,
      pipeColor: actualTheme.stepper.actual.pipeColor,
    },
    next: {
      iconName: 'circle',
      color: actualTheme.stepper.next.color,
      pipeColor: actualTheme.stepper.next.pipeColor,
    },
  };

  const containerRef = useRef();

  const changePage = useCallback(
    (i: number) => {
      if (index !== i) {
        const old = index;
        setIndex(i);
        aniamtion(containerRef, i, old);
      }
    },
    [index],
  );

  const handleIconClick = useCallback(
    (i: number) => () => {
      if (!disableNavigation && !disableSteps.includes(i)) changePage(i);
    },
    [changePage, disableNavigation, disableSteps],
  );
  return (
    <ThemeProvider theme={actualTheme}>
      <div>
        <StepperContainer>
          {steps.map(({ step }, i) => (
            <StepContainer lastChild={i >= steps.length - 1}>
              <StepWrapper>
                <IconWrapper>
                  <BasicIcon
                    name={IconConfig[step.status].iconName}
                    color={IconConfig[step.status].color}
                    onClick={handleIconClick(i)}
                    clickable={!disableNavigation && !disableSteps.includes(i)}
                  />
                </IconWrapper>
                <TitlesContainer>
                  <TitleContarner>{step.title}</TitleContarner>
                  <SubtileTitleContarner>{step.subtitle}</SubtileTitleContarner>
                </TitlesContainer>
              </StepWrapper>
              {i < steps.length - 1 && <Pipe color={IconConfig[step.status].pipeColor} />}
            </StepContainer>
          ))}
        </StepperContainer>

        <ContentSection>
          <ContentWrapper ref={containerRef}>
            {steps.map(({ Page }: any, i: number) => (
              <>
                {i === index && (
                  <ContentContainer>
                    <Page goTo={changePage} />
                  </ContentContainer>
                )}
              </>
            ))}
          </ContentWrapper>
        </ContentSection>
      </div>
    </ThemeProvider>
  );
};
